import { Col } from "ant-design-vue";
const { ...other } = Col;

const YwCol = {
	...other,
	name: "YwCol",
};

YwCol.install = function (Vue) {
	Vue.component(YwCol.name, Col);
};

export default YwCol;
